import { HexElementProperties } from '~/types/drill'
import { TOPIC_HEXAGON_PROPERTIES } from '~/shared/constants/drill.const'

export function getProperties(index: number): HexElementProperties {
  switch (index) {
    case 1:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
        color: 'aqua',
        i18nKey: 'playAlt',
        splat: 'left',
        classNames: {
          button: 'bg-white',
          text: 'whitespace-nowrap font-bold text-lg text-black',
        },
      }

    case 2:
    case 3:
    case 4:
    case 5:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.ACTIVITY,
      }

    default:
      return {
        ...TOPIC_HEXAGON_PROPERTIES.DEFAULT,
      }
  }
}
